// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { getQueryByConfig, QueryRegistryFactory } from '../../../contexts'

import { CUSTOMER_FRAGMENTS_MAP } from './graphql/fragments'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const profileQueries: QueryRegistryFactory = (config) => {
  const CUSTOMER_FRAGMENT = getQueryByConfig(config, CUSTOMER_FRAGMENTS_MAP)

  return ({
    changeEmailMutation: {
      type: 'mutation',
      query: gql`
        ${CUSTOMER_FRAGMENT}
        mutation($email: String!, $password: String!) {
          updateCustomer(
            input: {
              email: $email
              password: $password
            }
          ) {
            customer {
              ...CustomerFragment
            }
          }
        }`,
      meta: {
        noAuth: false
      }
    },
    changeEmailPhoneMutation: {
      type: 'mutation',
      query: gql`
          ${CUSTOMER_FRAGMENT}
          mutation($email: String!, $password: String!) {
              updateCustomer(
                  input: {
                      email: $email
                      password: $password
                  }
              ) {
                  customer {
                      ...CustomerFragment
                  }
              }
          }`,
      meta: {
        noAuth: false
      }
    },
    changePasswordMutation: {
      type: 'mutation',
      query: gql`
        mutation($password: String!, $newPassword: String!) {
          changeCustomerPassword(currentPassword: $password, newPassword: $newPassword) {
            id
            email
          }
        }`,
      meta: {
        noAuth: false
      }
    },
    changeUserDetailsMutation: {
      type: 'mutation',
      query: gql`
        ${CUSTOMER_FRAGMENT}
        mutation($firstName: String!, $lastName: String!, $dateOfBirth: String, $isB2BRequested: Boolean, $isExistingCompanyRequested: Boolean) {
          updateCustomer(
            input: {
              firstname: $firstName
              lastname: $lastName
              date_of_birth: $dateOfBirth
              is_b2b_requested: $isB2BRequested
              is_existing_company_requested: $isExistingCompanyRequested
            }
          ) {
            customer {
              ...CustomerFragment
            }
          }
        }`,
      meta: {
        noAuth: false
      }
    },
    customerQuery: {
      type: 'query',
      query: gql`
        ${CUSTOMER_FRAGMENT}
        query customer {
          customer {
            ...CustomerFragment
          }
        }
      `,
      meta: {}
    },
    storeDeliveryAddressQuery: {
      type: 'mutation',
      query: gql`
        mutation($firstName: String!, $lastName: String!, $defaultBilling: Boolean, $defaultShipping: Boolean, $street: [String]!, $city: String!, $postalCode: String, $company: String, $countryCode: CountryCodeEnum!, $phoneNumber: String!, $vatId: String, $region: CustomerAddressRegionInput) {
          createCustomerAddress(input: {
            firstname: $firstName
            lastname: $lastName
            country_code: $countryCode
            street: $street
            telephone: $phoneNumber
            postcode: $postalCode
            city: $city
            company: $company
            default_shipping: $defaultShipping
            default_billing: $defaultBilling
            vat_id: $vatId
            region: $region
          }) {
            firstname
            lastname
            id
            region {
              region
              region_code
            }
            country_code
            street
            telephone
            postcode
            city
            company
            vat_id
            default_billing
            default_shipping
          }
        }`,
      meta: {
        noAuth: false
      }
    },
    subscribeNewsletterMutation: {
      type: 'mutation',
      query: gql`
        ${CUSTOMER_FRAGMENT}
        mutation($isSubscribedNewsletter: Boolean!) {
          updateCustomer(
            input: {
              is_subscribed: $isSubscribedNewsletter
            }
          ) {
            customer {
              ...CustomerFragment
            }
          }
        }`,
      meta: {
        noAuth: false
      }
    },
    updateDeliveryAddressQuery: {
      type: 'mutation',
      query: gql`
        mutation($addressId: Int!, $defaultBilling: Boolean, $defaultShipping: Boolean, $firstName: String, $lastName: String, $street: [String], $city: String, $postalCode: String, $company: String, $countryCode: CountryCodeEnum, $phoneNumber: String, $vatId: String, $region: CustomerAddressRegionInput) {
          updateCustomerAddress(id:$addressId,input: {
            firstname: $firstName
            lastname: $lastName
            country_code: $countryCode
            street: $street
            telephone: $phoneNumber
            postcode: $postalCode
            city: $city
            company: $company
            default_shipping: $defaultShipping
            default_billing: $defaultBilling
            vat_id: $vatId
            region: $region
          }) {
            firstname
            lastname
            id
            region {
              region
              region_code
            }
            country_code
            street
            telephone
            postcode
            city
            company
            vat_id
            default_billing
            default_shipping
          }
        }`,
      meta: {
        noAuth: false
      }
    }
  })
}
